<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">产品列表</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <ul class="list-group">
          <li class="list-item" v-for="(item, index) in list" :class="getClazz(index)" @click="onItemClick(index)">
            <h1 class="item-title">{{item.name}}</h1>
            <div class="item-section">{{item.summary}}</div>
            <div class="item-bottom">{{item.remark}}</div>
            <div class="triangle"></div>
          </li>
        </ul>
      </scroller>
      <spinner :show="loading"></spinner>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'
  import Spinner from 'components/spinner/spinner'

  const cls = ['orange', 'blue', 'green', 'pink']

  export default {
    data () {
      return {
        list: [],
        loading: false,
        isFromDetail: false
      }
    },
    mounted () {
      this.sceneId = this.$route.query.id
      this.city = this.$cache.getCity()
      this._fetchData()
      this.$nextTick(() => {
        this._refresh()
      })
    },
    components: {
      Navbar,
      Scroller,
      Spinner
    },
    beforeRouteEnter (to, from, next) {
      let isFromDetail = /detail/.test(from.path)
      next(vm => {
        vm.isFromDetail = isFromDetail
      })
    },
    methods: {
      _fetchData () {
        let vm = this
        let url = this.sceneId ? '/getProductByScene.jhtml' : '/getProductByCity.jhtml'
        this.loading = true
        this.$ajax({
          url: url,
          params: {
            sceneId: vm.sceneId,
            cityNo: vm.city.code,
            isPage: 'y',
            pageNumber: 1
          },
          done (list, page) {
            vm.list = list
            if (vm.list.length === 1) {
              if (vm.isFromDetail) {
                vm.$router.push(`/borrow`)
              } else {
                vm.onItemClick(0)
              }
            }
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.loading = false
            vm._refresh()
          }
        })
      },
      _refresh () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 0)
          }
        })
      },
      getClazz (index) {
        return cls[index % 4]
      },
      onItemClick (index) {
        let item = this.list[index]
        this.$router.push(`/borrow/detail/${item.id}`)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  ul, li
    margin 0
    padding 0
    list-style-type none

  .triangle
    position absolute
    top 50%
    margin-top px2rem(-8)
    right px2rem(20)
    width 0
    height 0
    border-bottom px2rem(8) solid transparent
    border-top px2rem(8) solid transparent
    border-left px2rem(8) solid #275482

  .list-group
    padding 1px 1em

    .list-item
      position relative
      overflow hidden
      margin-top px2rem(20)
      margin-bottom px2rem(20)
      padding px2rem(20) px2rem(45) px2rem(20) px2rem(30)
      line-height 1.4
      text-align justify
      border-radius px2rem(5)
      background-color #fff
      box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

      &:before
        content ''
        position absolute
        top 0
        left 0
        width px2rem(10)
        height 100%
      &.orange:before
        background linear-gradient(to top,#f7a56e,#ef8160)
      &.blue:before
        background linear-gradient(to top,#8ccae0,#26a1e1)
      &.green:before
        background linear-gradient(to top,#6ef794,#44ad62)
      &.pink:before
        background linear-gradient(to top,#f884b5,#a36cd1)

      .item-title
        margin-top 0
        margin-bottom px2rem(20)
        font-size px2rem(34)
        color #275482

      .item-section
        margin-bottom px2rem(20)
        font-size px2rem(28)
        color #275482

      .item-bottom
        font-size px2rem(24)
        color #4e465a

</style>



// WEBPACK FOOTER //
// explain.vue?cf336208